import api, { withLoading } from '@/api/api';

const resource = `v1/ict/participantes`;
const LOADING_KEY = 'ict-participantes';

export default {
    getAll(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
    getOne(empresaId, participanteId) {
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/${participanteId}`).then(res => res.data)
        );
    },
    create(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}`, data).then(res => res.data)
        );
    },
    update(empresaId, participanteId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/${participanteId}`, data).then(res => res.data)
        );
    },
    delete(empresaId, participanteId) {
        return withLoading(LOADING_KEY, () =>
            api.delete(`${resource}/${empresaId}/${participanteId}`).then(res => res.data)
        );
    }
}
